import { Injectable, signal } from '@angular/core';
export interface Alert { id: number; type: 'success' | 'error' | 'info' | 'warning'; message: string; title?: string; closing: boolean; }
@Injectable({ providedIn: 'root' })
export class AlertService {
  private readonly alertsSignal = signal<Alert[]>([]);
  readonly alerts = this.alertsSignal.asReadonly();
  private nextId = 1;
  private readonly autoCloseTimers = new Map<number, ReturnType<typeof setTimeout>>();
  private readonly removeTimers = new Map<number, ReturnType<typeof setTimeout>>();
  success(message: string, title?: string): void { this.addAlert(message, 'success', title); }
  error(message: string, title?: string): void { this.addAlert(message, 'error', title); }
  info(message: string, title?: string): void { this.addAlert(message, 'info', title); }
  warn(message: string, title?: string): void { this.addAlert(message, 'warning', title); }
  removeAlert(id: number): void {
    const target=this.alertsSignal().find(a=>a.id===id); if(!target)return; this.clearAuto(id);
    if(target.closing){this.destroy(id);return;}
    this.alertsSignal.update(items=>items.map(a=>a.id===id?{...a,closing:true}:a));
    this.removeTimers.set(id,setTimeout(()=>this.destroy(id),350));
  }
  private addAlert(message:string,type:Alert['type'],title?:string):void{
    const item:Alert={id:this.nextId++,type,message,title,closing:false};
    this.alertsSignal.update(items=>[item,...items].slice(0,4));
    this.autoCloseTimers.set(item.id,setTimeout(()=>this.removeAlert(item.id),2500));
  }
  private destroy(id:number):void{this.clearAuto(id);const timer=this.removeTimers.get(id);if(timer)clearTimeout(timer);this.removeTimers.delete(id);this.alertsSignal.update(items=>items.filter(a=>a.id!==id));}
  private clearAuto(id:number):void{const timer=this.autoCloseTimers.get(id);if(timer)clearTimeout(timer);this.autoCloseTimers.delete(id);}
}
